/**
 * Publish Google Workspace integration activities to the Mycelium backbone.
 *
 * @module mycelium-integration-publish
 */

import { mapActivityEventToMycelium } from '@flowstate/mycelium-core';
import { getMyceliumTransport } from './mycelium-transport-registry';
import { logger } from '../lib/logger';

export interface PublishIntegrationActivityParams {
  userId: string;
  organizationId: string;
  activityId: string;
  activityDomain: 'gmail' | 'calendar' | 'gtasks' | string;
  eventType: string;
  payload: Record<string, unknown>;
}

/**
 * Fire-and-forget backbone publish after activity log write.
 */
export async function publishIntegrationActivity(
  params: PublishIntegrationActivityParams,
): Promise<void> {
  const { domain, type } = mapActivityEventToMycelium(
    params.activityDomain,
    params.eventType,
  );

  try {
    const result = await getMyceliumTransport().publish({
      domain,
      type,
      userId: params.userId,
      orgId: params.organizationId,
      payload: {
        activityId: params.activityId,
        activityDomain: params.activityDomain,
        eventType: params.eventType,
        source: 'IntegrationActivityService',
        ...params.payload,
      },
    });

    if (!result.success) {
      logger.warn('IntegrationActivity: backbone publish failed', {
        domain,
        type,
        error: result.error,
      });
    }
  } catch (error) {
    logger.warn('IntegrationActivity: backbone publish error', {
      domain,
      type,
      error: error instanceof Error ? error.message : String(error),
    });
  }
}
